<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <router-link :to="{ name: 'studyResult' }">Hasil Kuliah</router-link>
                    <span class="separator">/</span>
                    <span>Markah Komponen</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Markah Komponen</h2>
                <p class="page-subtitle">Status pemberian markah bagi setiap komponen</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-6">

                    <template v-if="detail">
                        <!-- Maklumat madah -->
                        <div class="info-card mb-3">
                            <span class="list-item-code">{{ detail.subject.s_code }} · Semester {{ detail.subject.semester }} / {{ detail.subject.year }}</span>
                            <div class="info-card-title mt-1">{{ detail.subject.s_rumiName }}</div>
                            <div class="detail-row">
                                <i class="fas fa-user-tie"></i>
                                <span>{{ detail.subject.teacher || '-' }}</span>
                            </div>

                            <div class="mt-3">
                                <div class="d-flex justify-content-between mb-1">
                                    <small class="text-muted">Sudah diberi markah</small>
                                    <small class="font-weight-bold">{{ detail.summary.received }} / {{ detail.summary.total }} komponen</small>
                                </div>
                                <div class="progress" style="height: 8px;">
                                    <div class="progress-bar bg-success" :style="{ width: receivedPercent + '%' }"></div>
                                </div>
                            </div>
                        </div>

                        <!-- Senarai komponen -->
                        <div class="collapsible-card">
                            <div class="list-item d-flex align-items-center" v-for="(item, index) in detail.items" :key="item.id">
                                <span class="list-item-number">{{ index + 1 }}</span>
                                <div class="list-item-info flex-grow-1 mx-3">
                                    <span class="list-item-code">{{ typeLabels[item.type] }}</span>
                                    <span class="list-item-name">{{ item.name }}</span>
                                </div>
                                <span class="score-badge text-nowrap" :class="statusOf(item).class">
                                    <i :class="statusOf(item).icon"></i> {{ statusOf(item).label }}
                                </span>
                            </div>

                            <div v-if="!detail.items.length" class="empty-state-sm">
                                <i class="fas fa-inbox"></i>
                                <p>Tiada komponen markah</p>
                            </div>
                        </div>
                    </template>

                    <div v-else-if="notFound" class="empty-state">
                        <i class="fas fa-search"></i>
                        <p>Madah tidak dijumpai</p>
                    </div>

                    <div class="text-center mt-4">
                        <router-link :to="{ name: 'studyResult' }" class="btn-outline d-inline-block text-decoration-none">
                            <i class="fas fa-arrow-left"></i> Kembali
                        </router-link>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
const TYPE_LABELS = {
    collect: 'Markah Kerja Kursus',
    midterm: 'Peperiksaan Pertengahan',
    final: 'Peperiksaan Akhir',
}

const EXAM_STATUS = {
    tidak_periksa: { label: 'Tidak Periksa', class: 'danger', icon: 'fas fa-times-circle' },
    tidak_layak_periksa: { label: 'Tidak Layak Periksa', class: 'danger', icon: 'fas fa-ban' },
}

export default {
    name: 'StudyResultMarkahKomponen',
    props: {
        rs: { type: String, required: true },
    },
    data() {
        return {
            loading: false,
            notFound: false,
            typeLabels: TYPE_LABELS,
        }
    },
    computed: {
        detail() {
            return this.$store.state.studyResultMarkah.details[this.rs] || null
        },
        receivedPercent() {
            if (!this.detail.summary.total) return 0
            return Math.round((this.detail.summary.received / this.detail.summary.total) * 100)
        },
    },
    mounted() {
        this.loadDetail()
    },
    methods: {
        async loadDetail() {
            this.loading = true
            this.notFound = false
            this.$Progress.start()
            try {
                await this.$store.dispatch('studyResultMarkah/fetchMarkahKomponen', this.rs)
                this.$Progress.finish()
            } catch (error) {
                this.notFound = !!(error.response && error.response.status === 404)
                this.handleApiError(error)
            } finally {
                this.loading = false
            }
        },

        statusOf(item) {
            if (item.exam_status) return EXAM_STATUS[item.exam_status]
            return item.received
                ? { label: 'Sudah diberi markah', class: 'success', icon: 'fas fa-check-circle' }
                : { label: 'Belum diberi markah', class: 'warning', icon: 'far fa-clock' }
        },

        handleApiError(error) {
            this.$Progress.fail()
            if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                this.$store.dispatch('authentication/cencelAuthen')
            }
            // eslint-disable-next-line no-console
            console.log(error)
        },
    },
}
</script>

<style scoped>
.collapsible-card {
    background: #fff;
}
</style>
